import { render } from "./Bi.vue?vue&type=template&id=253428aa"
import script from "./Bi.vue?vue&type=script&lang=js"
export * from "./Bi.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__